<template>
    <form id="sign-up-form" method="POST">

        <div class="row">
            <div class="col-12">
                <div class="bs-stepper">
                    <div class="bs-stepper-header margin-bottom-20" role="tablist">

                        <!-- Steps -->
                        <div class="step" data-target="#travel-agency-step">
                            <button type="button" class="step-trigger" role="tab" aria-controls="travel-agency-step"
                                    id="travel-agency-step-trigger">
                                <i class="material-icons">work_outline</i><br>
                                <span class="bs-stepper-circle">1</span><br>
                                <span class="bs-stepper-label d-none d-sm-block padding-top-10">Travel Agency</span>
                            </button>
                        </div>
                        <div class="line"></div>
                        <div class="step" data-target="#travel-agent-step">
                            <button type="button" class="step-trigger" role="tab" aria-controls="travel-agent-step"
                                    id="travel-agent-step-trigger">
                                <i class="material-icons">person_outline</i><br>
                                <span class="bs-stepper-circle">2</span><br>
                                <span class="bs-stepper-label d-none d-sm-block padding-top-10">Travel Agent</span>
                            </button>
                        </div>
                        <div class="line"></div>
                        <div class="step" data-target="#final-steps">
                            <button type="button" class="step-trigger" role="tab" aria-controls="travel-agent-step"
                                    id="final-steps-trigger">
                                <i class="material-icons">lock</i><br>
                                <span class="bs-stepper-circle">3</span><br>
                                <span class="bs-stepper-label d-none d-sm-block padding-top-10">Set Password</span>
                            </button>
                        </div>
                    </div>
                    <div class="box-form bg-white box-shadow rounded">
                        <div class="bs-stepper-content padding-0">

                            <!-- Travel Agency Info, Step 1 -->
                            <div id="travel-agency-step" class="content" role="tabpanel" aria-labelledby="travel-agency-step-trigger">

                                <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Please provide Travel Agency Information</h1>

                                <div class="row">
                                    <!-- Identifier Type -->
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">Identifier Type</label>
                                        <i class="material-icons">business</i>
                                        <select id="identifier_type_select" name="identifier_type" class="form-control input-style"
                                                v-model="travelAgencyForm.identifier_type">
                                            <option value="IATA" selected>IATA</option>
                                            <option value="ARC">ARC</option>
                                            <option value="CLIA">CLIA</option>
                                            <option value="TRUE">TRUE</option>
                                        </select>
                                        <i class="material-icons select_arrow_down">keyboard_arrow_down</i>
                                    </div>

                                    <!-- Identifier Number -->
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">Identifier No.</label>
                                        <i class="material-icons">business</i>
                                        <input name="identifier-no" type="text" class="form-control input-style"
                                                v-model="travelAgencyForm.identifier_number"
                                                aria-describedby="Identifier Number">
                                        <p class="help text-danger margin-0" v-if="$v.travelAgencyForm.identifier_number.$error">This field is required</p>
                                    </div>
                                </div>

                                <div class="row" v-if="askForTravelAgencyInfo">
                                    <!-- Agency Name -->
                                    <div class="col-12 col-lg-6 form-group">
                                        <label class="font-sm">Agency Name</label>
                                        <i class="material-icons">business</i>
                                        <input name="travel-agency-name" type="text" class="form-control input-style"
                                                v-model="travelAgencyForm.name"
                                                aria-describedby="Travel agency name">
                                        <p class="help text-danger margin-0" v-if="$v.travelAgencyForm.name.$error">This field is required</p>
                                    </div>

                                    <!-- Affiliations -->
                                    <div class="col-12 col-lg-6 form-group">
                                        <label class="font-sm">Affiliations</label>
                                        <i class="material-icons">business</i>
                                        <input name="zip" type="text" class="form-control input-style"
                                                aria-describedby="Consortia affiliation"
                                                v-model="travelAgencyForm.consortia_affiliation"
                                                :disabled="travelAgencyForm.consortia_affiliation === 'None'">
                                        <div class="form-check margin-top-10">
                                            <input class="form-check-input" type="checkbox" id=""
                                                    v-on:input="travelAgencyForm.consortia_affiliation = $event.target.checked ? 'None' : ''">
                                            <label class="form-check-label">None</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="askForTravelAgencyInfo">
                                    <!-- Address -->
                                    <div class="col-12 form-group">
                                        <label class="font-sm">Address</label>
                                        <i class="material-icons">room</i>
                                        <input name="address" type="text" class="form-control input-style"
                                                aria-describedby="Address"
                                                v-model="travelAgencyForm.address">
                                        <p class="help text-danger margin-0" v-if="$v.travelAgencyForm.address.$error">This field is required</p>
                                    </div>
                                </div>

                                <div class="row" v-if="askForTravelAgencyInfo">
                                    <!-- City -->
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">City</label>
                                        <i class="material-icons">room</i>
                                        <input name="city" type="text" class="form-control input-style"
                                                aria-describedby="City"
                                                v-model="travelAgencyForm.city">
                                        <p class="help text-danger margin-0" v-if="$v.travelAgencyForm.city.$error">This field is required</p>
                                    </div>

                                    <!-- State -->
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">State</label>
                                        <i class="material-icons">room</i>
                                        <input name="state" type="text" class="form-control input-style"
                                                aria-describedby="State"
                                                v-model="travelAgencyForm.state">
                                        <p class="help text-danger margin-0" v-if="$v.travelAgencyForm.state.$error">This field is required</p>
                                    </div>
                                </div>

                                <div class="row" v-if="askForTravelAgencyInfo">
                                    <!-- Country -->
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">Country</label>
                                        <i class="material-icons">room</i>
                                        <input name="country" type="text" class="form-control input-style"
                                                aria-describedby="Country"
                                                v-model="travelAgencyForm.country">
                                        <p class="help text-danger margin-0" v-if="$v.travelAgencyForm.country.$error">This field is required</p>
                                    </div>

                                    <!-- Zip Code -->
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">Zip</label>
                                        <i class="material-icons">room</i>
                                        <input name="zip" type="text" class="form-control input-style"
                                                aria-describedby="Zip code"
                                                v-model="travelAgencyForm.zip">
                                        <p class="help text-danger margin-0" v-if="$v.travelAgencyForm.zip.$error">This field is required</p>
                                    </div>
                                </div>

                                <!-- Next Btn -->
                                <div class="row margin-top-20 margin-bottom-20 justify-content-center">
                                    <div class="col-auto">
                                        <button type="button"
                                                class="btn btn-primary btn-lg text-uppercase"
                                                :disabled="!travelAgencyNextActionAvailable"
                                                @click="travelAgencyNextAction()">
                                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Next
                                        </button>
                                    </div>
                                </div>

                            </div>

                            <!-- Travel Agent Info, Step 2 -->
                            <div id="travel-agent-step" class="content" role="tabpanel" aria-labelledby="travel-agent-step-trigger">

                                <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Please provide Travel Agent Information</h1>

                                <div class="row">
                                    <div class="col-12">
                                        <p>Travel Agency <strong>"{{ travelAgencyForm.name }}"</strong></p>
                                    </div>
                                </div>

                                <!-- Email -->
                                <div class="row">
                                    <div class="col-12 col-lg-6 form-group">
                                        <label class="font-sm">Email</label>
                                        <i class="material-icons">mail_outline</i>
                                        <input name="agent_email" type="text" class="form-control input-style"
                                            :disabled="loading || fetchedMember"
                                            v-model="memberForm.email"
                                            aria-describedby="Email Address">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.email.$error">Please provide a valid e-mail address.</p>
                                    </div>
                                    <div class="col-12 col-lg-6 form-group" v-if="askForMemberInfo">
                                        <label class="font-sm">Phone</label>
                                        <i class="material-icons">phone_iphone</i>
                                        <input name="agent_phone" type="tel" class="form-control input-style"
                                               v-model="memberForm.phone"
                                               aria-describedby="Phone Number" />
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.phone.$error">Please provide a valid phone number.</p>
                                    </div>
                                </div>

                                <!-- First and Last Name -->
                                <div class="row" v-if="askForMemberInfo">
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">First Name</label>
                                        <i class="material-icons">person_outline</i>
                                        <input name="agent_first_name" type="text" class="form-control input-style"
                                            v-model="memberForm.first_name"
                                            aria-describedby="First Name">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.first_name.$error">This field is required</p>
                                    </div>

                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">Last Name</label>
                                        <i class="material-icons">person_outline</i>
                                        <input name="agent_last_name" type="text" class="form-control input-style"
                                            v-model="memberForm.last_name"
                                            aria-describedby="First Name">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.last_name.$error">This field is required</p>
                                    </div>
                                </div>

                                <!-- Address -->
                                <div class="row" v-if="askForMemberInfo">
                                    <div class="col-12 form-group">
                                        <label class="font-sm">Address</label>
                                        <i class="material-icons">room</i>
                                        <input name="agent_address" type="text" class="form-control input-style"
                                            aria-describedby="Address"
                                            v-model="memberForm.address">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.address.$error">This field is required</p>
                                    </div>
                                </div>

                                <div class="row" v-if="askForMemberInfo">
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">City</label>
                                        <i class="material-icons">room</i>
                                        <input name="agent_city" type="text" class="form-control input-style"
                                            aria-describedby="City"
                                            v-model="memberForm.city">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.city.$error">This field is required</p>
                                    </div>

                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">State</label>
                                        <i class="material-icons">room</i>
                                        <input name="agent_state" type="text" class="form-control input-style"
                                            aria-describedby="State"
                                            v-model="memberForm.state">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.state.$error">This field is required</p>
                                    </div>
                                </div>

                                <div class="row" v-if="askForMemberInfo">
                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">Country</label>
                                        <i class="material-icons">room</i>
                                        <input name="agent_country" type="text" class="form-control input-style"
                                            aria-describedby="Country"
                                            v-model="memberForm.country">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.country.$error">This field is required</p>
                                    </div>

                                    <div class="col-12 col-md-6 form-group">
                                        <label class="font-sm">Zip</label>
                                        <i class="material-icons">room</i>
                                        <input name="agent_zip" type="text" class="form-control input-style"
                                            aria-describedby="Zip code"
                                            v-model="memberForm.zip">
                                        <p class="help text-danger margin-0" v-if="$v.memberForm.zip.$error">This field is required</p>
                                    </div>
                                </div>

                                <!-- Next Btn -->
                                <div class="row margin-top-20 margin-bottom-20 justify-content-center">
                                    <div class="col-auto">
                                        <button
                                                type="button"
                                                class="btn btn-primary btn-lg text-uppercase"
                                                :disabled="!memberNextActionAvailable"
                                                @click="memberNextAction()">
                                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Next
                                        </button>
                                    </div>
                                </div>

                            </div>

                            <!-- Create Account, Step 3 -->
                            <div id="final-steps" class="content" role="tabpanel" aria-labelledby="final-steps-trigger">

                                <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Set Password</h1>

                                <!-- Setup Password Email Sent -->
                                <div v-if="finalStepMessage === 'SETUP_PASSWORD'">
                                    <div class="row">
                                        <div class="col-12">
                                            <p>
                                                <strong>Dear {{memberForm.first_name}},</strong><br><br>

                                                We've sent you an email with instructions on how to setup a password
                                                for your account.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Info Sent to BDM -->
                                <div v-if="finalStepMessage === 'SENT_TO_BDM'">
                                    <div class="row">
                                        <div class="col-12">
                                            <p>
                                                <strong>Dear {{memberForm.first_name}},</strong><br><br>

                                                We'd like to inform you that we received your information. Our Business
                                                Development team is currently receiving your information and will be
                                                planning a call with you shortly.<br><br>
                                                Thank you, again, for taking the time to contact us with your request.<br>
                                                Best regards.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Account Already Setup, go to Login -->
                                <div v-if="finalStepMessage === 'ALREADY_SETUP'">
                                    <div class="row">
                                        <div class="col-12">
                                            <p>
                                                <strong>Dear {{memberForm.first_name}},</strong><br><br>

                                                It seems you've already setup an account with us. Please head over
                                                to the <a class="link-style" href="/forgot-password">Forgot Password Page</a>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bs-stepper/dist/css/bs-stepper.min.css">
    </form>

</template>

<script>
    import {validationMixin} from "vuelidate";
    import {required, requiredIf, email, numeric} from 'vuelidate/lib/validators'
    import Loader from "../../misc/Loader";
    import DotsLoader from "../../misc/DotsLoader";
    import Stepper from "bs-stepper";
    import _ from "lodash"

    export default {
        mixins: [validationMixin],
        components: {
            Loader,
            DotsLoader
        },
        externalRewardType: null,
        stepper: null,

        computed: {
            /**
             * Hides or shows the Travel Agency Form
             * @returns {boolean}
             */
            askForTravelAgencyInfo () {
                return this.fetchedTravelAgency && !this.travelAgencyForm.id

            },

            /**
             * Hides or shows the Travel Agent form
             * @returns {boolean}
             */
            askForMemberInfo() {
                return this.fetchedMember && !this.memberForm.id;
            },

            /**
             * Enables or disables the Travel Agency step "Next" button
             * @returns {boolean|null}
             */
            travelAgencyNextActionAvailable () {

                return (
                    (!this.fetchedTravelAgency) ||
                    (this.fetchedTravelAgency && this.travelAgencyForm.id) ||
                    (this.fetchedTravelAgency && !this.travelAgencyForm.id && !this.$v.travelAgencyForm.$invalid)
                );
            },

            /**
             * Enables or disables the Travel Agent step "Next" button
             * @returns {boolean|null}
             */
            memberNextActionAvailable() {

                return (
                    (!this.fetchedMember) ||
                    (this.fetchedMember && this.memberForm.id) ||
                    (this.fetchedMember && !this.memberForm.id && !this.$v.memberForm.$invalid)
                );
            },

            /**
             * The agent's travel agency does not match the info provided in the
             * travel agency form
             */
            travelAgencyMismatch() {

                if (!this.memberForm.travelAgency)
                    return false;

                const compareNumber = this.memberForm.travelAgency[this.travelAgencyForm.identifier_type];
                const compareNumberParent = _.get(this.memberForm, `travelAgency.parent.${this.travelAgencyForm.identifier_type}`);

                const mismatch = Boolean(!compareNumber || compareNumber !== this.travelAgencyForm.identifier_number);
                const mismatchParent = Boolean(!compareNumberParent || compareNumberParent !== this.travelAgencyForm.identifier_number);

                return (
                    this.memberForm.id &&
                    (mismatch && mismatchParent)
                );
            }
        },
        data() {
            return {
                /**
                 * Current step in the process
                 */
                step: 0,

                loading: false,

                /**
                 * Travel Agency was fetched with the current identifier
                 */
                fetchedTravelAgency: false,

                /**
                 * Travel Agent was fetched with the current email
                 */
                fetchedMember: false,

                finalStepMessage: 'default',

                /**
                 * Travel Agency Form
                 */
                travelAgencyForm: {
                    id: null,
                    identifier_type: 'IATA',
                    identifier_number: '',
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: '',
                    consortia_affiliation: '',
                },

                /**
                 * Travel Agent Form
                 */
                memberForm: {
                    id: null,
                    email: '',
                    username: '',
                    first_name: '',
                    last_name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: '',
                    phone: '',
                    travelAgency: {},
                },

                referrerExternalId: null,
            }
        },

        methods: {
            /**
             * Fetches a travel agency based on given identifier,
             * fills form if an agency was found.
             * @returns {Promise<boolean>}
             */
            async fetchTravelAgency() {
                this.loading = true;

                const {identifier_type, identifier_number} = this.travelAgencyForm;

                if (!identifier_number) {
                    this.$v.travelAgencyForm.identifier_number.$touch();

                    return false;
                }
                const response =
                    await this
                        .$httpClient
                        .request("get", `/api/travel-agencies/get-by-identifier/${identifier_type}/${identifier_number}`);

                this.fetchedTravelAgency = true;

                this.loading = false;

                if (response.data)
                    this.travelAgencyForm = {
                        ...this.travelAgencyForm, ..._.pick(
                            response.data,
                            'id',
                            'name',
                            'address',
                            'city',
                            'state',
                            'country',
                            'zip',
                            'consortia_affiliation'
                        )
                    };
                else
                    return false;

                return true;
            },

            /**
             * Fetches a travel agent based on a given email, fills the travel agent
             * form if an agent was found.
             * @returns {Promise<boolean>}
             */
            async fetchMember() {
                const {
                    memberForm: {email},
                    $v: {memberForm: validator}
                } = this;

                if (!email || validator.email.$invalid) {
                    validator.email.$touch();
                    validator.$touch();

                    return false;
                }

                this.loading = true;

                const response = await this
                    .$httpClient
                    .request("get", `/api/members/get-by-email/${email}`);

                this.fetchedMember = true;

                this.loading = false;

                if (response.data) {
                    this.memberForm = {
                        ...this.memberForm, ..._.pick(
                            response.data,
                            'id',
                            'first_name',
                            'last_name',
                            'address',
                            'username',
                            'city',
                            'state',
                            'country',
                            'zip'
                        )
                    };

                    this.memberForm.travelAgency = response.data.travelAgency;

                  if (this.externalRewardType)
                    await this
                        .$httpClient
                        .request("post", `/api/services/external-rewards/set-pending-enrollment/${response.data.id}?type=${this.externalRewardType}`);
                }
                else {
                    return false;
                }

                return true;
            },

            /**
             * Sends account setup instructions to the given email
             * @returns {Promise<boolean>}
             */
            async sendAccountSetupInstructions() {
                this.loading = true;

                const data = {
                  member: this.memberForm,
                  travelAgency: this.travelAgencyForm,
                };

                const response = await this.$httpClient
                    .request("post", `api/actions/send-account-setup`, data, false, true);


                if (response.status === 'ERROR' && response.data && response.data.error)
                {
                    switch (response.data.error) {
                        case "ALREADY_SETUP":
                            this.finalStepMessage = 'ALREADY_SETUP';
                            return true;
                        default:
                            this.$snotify.error("", {
                                html: `<div class="snotifyToast__body" style="width: 100%">
                                             ${response.messages.join("<br>")}
                                       </div>`});
                    }
                } else if (response.status === 'ERROR') {
                    this.$snotify.error("", {
                        html: `<div class="snotifyToast__body" style="width: 100%">
                                             ${response.messages.join("<br>")}
                                       </div>`});
                }

                this.finalStepMessage = 'SETUP_PASSWORD';

                this.loading = false;

                return response.status !== 'ERROR';
            },

            /**
             * Sends the provided info to the BDM for review
             * @returns {Promise<boolean>}
             */
            async sendInfoToBDM() {
                this.loading = true;

                const data = {
                    travelAgency: this.travelAgencyForm,
                    member: this.memberForm,
                    referrerExternalId: this.referrerExternalId,
                };

                const response = await this
                        .$httpClient
                        .request("post", `/api/actions/request-registration`, data);

                this.loading = false;

                if (response.status === 'ERROR')
                    return false;

                this.finalStepMessage = 'SENT_TO_BDM';

                return true;
            },

            /**
             * Checks if user should proceed to the next step.
             * @returns {Promise<*|void>}
             */
            async travelAgencyNextAction() {
                if (!this.fetchedTravelAgency && await this.fetchTravelAgency())
                    return this.nextStep();

                if (this.fetchedTravelAgency && !this.travelAgencyForm.id && !this.$v.travelAgencyForm.$invalid)
                    return this.nextStep();
            },

            /**
             * Checks if user should proceed to the next step
             * @returns {Promise<*|void>}
             */
            async memberNextAction() {

                /**
                 * Fetch Travel Agent from email
                 */
                if (!this.fetchedMember) {
                    const response = await this.fetchMember();

                    /**
                     * Account is already setup
                     */
                    if (this.memberForm.username && !this.travelAgencyMismatch)
                    {
                        this.finalStepMessage = 'ALREADY_SETUP';

                        return this.nextStep();
                    }

                    /**
                     * In case of error do nothing
                     */
                    if (!response)
                        return;
                }

                /**
                 * Agent was fetched but it's travel agency does not match the input travel agency number or member
                 * is a direct client
                 */
                if (this.fetchedMember && this.travelAgencyMismatch || (this.memberForm.id && !this.memberForm.travelAgency))
                {
                    const sendToBdmResponse = await this.sendInfoToBDM();

                    if (!sendToBdmResponse)
                        return false;

                    return this.nextStep();
                }

                /**
                 * Send account setup instructions.
                 */
                if (
                    this.memberForm.id &&
                    this.travelAgencyForm.id &&
                    this.memberForm.email &&
                    await this.sendAccountSetupInstructions())
                    return this.nextStep();

                /**
                 * Send info to BDM
                 */
                if (
                    this.fetchedMember &&
                    !this.memberForm.id &&
                    !this.$v.memberForm.$invalid &&
                    await this.sendInfoToBDM()
                )
                    return this.nextStep();
            },

            /**
             * Next step
             */
            nextStep() {
                this.step++;
                this.stepper.next();
            },

            /**
             * Previous step
             */
            prevStep() {
                this.step--;
                this.stepper.previous();
            },
        },


        validations: {
            travelAgencyForm: {
                identifier_type: {required},
                identifier_number: {required},
                name: {required},
                address: {required},
                city: {required},
                state: {required},
                zip: {required},
                country: {required},
                consortia_affiliation: {required},
            },
            memberForm: {
                email: {required, email},
                first_name: {required},
                last_name: {required},
                address: {required},
                city: {required},
                state: {required},
                zip: {required},
                country: {required},
                phone: {required},
            }
        },

        mounted() {
            /**
             * Initialize the stepper
             * @type {Stepper}
             */
            this.stepper = new Stepper(document.querySelector('.bs-stepper'));
            this.externalRewardType = this.$route.query.external_reward;

            /**
            * Set referrer external id if exist in query params
            */
            if(this.$route.query.rafd)
            {
               this.referrerExternalId = this.$route.query.rafd;
            }
        }
    }
</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>
